var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightSquare = function SvgRightSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#right-square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACB3",
    fillRule: "evenodd",
    d: "M21.53 5.368c1.026 1.394 1.026 3.382 1.026 7.36 0 3.976 0 5.965-1.026 7.359-.331.45-.732.846-1.188 1.173-1.412 1.013-3.426 1.013-7.453 1.013s-6.041 0-7.453-1.013a5.3 5.3 0 0 1-1.188-1.173c-1.026-1.394-1.026-3.383-1.026-7.36s0-5.965 1.026-7.36c.331-.45.732-.845 1.188-1.172 1.412-1.013 3.425-1.013 7.453-1.013 4.027 0 6.041 0 7.453 1.013.456.327.857.723 1.188 1.173"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#right-square_svg__b)",
    strokeLinecap: "round",
    d: "M21.53 5.368c1.026 1.394 1.026 3.382 1.026 7.36 0 3.976 0 5.965-1.026 7.359-.331.45-.732.846-1.188 1.173-1.412 1.013-3.426 1.013-7.453 1.013s-6.041 0-7.453-1.013a5.3 5.3 0 0 1-1.188-1.173c-1.026-1.394-1.026-3.383-1.026-7.36s0-5.965 1.026-7.36c.331-.45.732-.845 1.188-1.172 1.412-1.013 3.425-1.013 7.453-1.013 4.027 0 6.041 0 7.453 1.013.456.327.857.723 1.188 1.173Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.181 9.05a.79.79 0 0 1-.005-1.125.813.813 0 0 1 1.14-.005l1.547 1.515c.576.563 1.056 1.033 1.399 1.454.359.442.632.906.705 1.472a2.9 2.9 0 0 1 0 .733c-.073.565-.346 1.03-.705 1.471-.343.421-.823.891-1.399 1.455l-1.548 1.515a.813.813 0 0 1-1.139-.005.79.79 0 0 1 .005-1.125l1.515-1.483c.617-.604 1.031-1.01 1.31-1.353l.037-.046h-7.45a.8.8 0 0 1-.806-.796.8.8 0 0 1 .806-.795h7.45l-.037-.046c-.279-.342-.693-.75-1.31-1.354z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-square_svg__b",
    x1: 22.556,
    x2: 3.456,
    y1: 3.182,
    y2: 22.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "right-square_svg__a",
    width: 68.333,
    height: 68.091,
    x: -21.278,
    y: -21.318,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_796",
    result: "shape"
  })))));
};
export { SvgRightSquare as ReactComponent };